import { createContext } from "react";

const contatosContext = createContext()

export default contatosContext